import { formatDbEventDateYmd, type DbEventDateFields } from '../../utils/eventDbDateTime';

/** Manage Tickets sends this window when Today / Tomorrow / Next 7 days / custom is off. */
export function isUnfilteredManageTicketDateWindow(
  startDate?: string | null,
  endDate?: string | null,
): boolean {
  const start = String(startDate || '').trim().slice(0, 10);
  const end = String(endDate || '').trim().slice(0, 10);
  if (!start && !end) return true;
  return Boolean(start && end && start <= '1970-01-02' && end >= '9999-01-01');
}

export function ticketHasConcreteEventDate(ticket: DbEventDateFields): boolean {
  return Boolean(formatDbEventDateYmd(ticket));
}

/** N/A and Date TBD rows stay visible only when no event-date filter is applied. */
export function excludeUndatedTicketsForDateFilter<T extends DbEventDateFields>(
  tickets: T[],
  startDate?: string | null,
  endDate?: string | null,
): T[] {
  if (isUnfilteredManageTicketDateWindow(startDate, endDate)) return tickets;
  return tickets.filter((ticket) => ticketHasConcreteEventDate(ticket));
}
